import React from 'react';

import { CalendarOutlined } from '@ant-design/icons';
import { DatePickerProps } from 'antd/lib/date-picker';
import styled from 'styled-components';

import DatePicker from 'components/lib/DatePicker';

const DatePickerContainer = styled.div`
  position: relative;

  &&& .ant-picker {
    width: 100%;
  }

  &&& .ant-picker-input input {
    padding-left: 19px;
    margin-top: 2px;
  }
`;

const CalendarIcon = styled(CalendarOutlined)`
  position: absolute;
  top: 11px;
  left: 10px;
  z-index: 1;
  color: var(--text-secondary);
  pointer-events: none;
`;

const CreateEditActionPlansModalItemDatePicker = (props: DatePickerProps) => (
  <DatePickerContainer>
    <CalendarIcon />
    <DatePicker placement="bottomLeft" placeholder="Enter Date" {...props} />
  </DatePickerContainer>
);

export default CreateEditActionPlansModalItemDatePicker;
